module.exports = __webpack_public_path__ + "static/media/blue_tint.e38a8cf0.jpg";